module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_m_melanistic.ec92218e.png";